import { CompsInsightsRequest, CompsInsightsResponse, CompsSubmarketMappings } from 'src/common-services'
import { BaseClient } from 'src/common-services/clients/base-client'

export class CompsClient extends BaseClient {
  getInsights(request: CompsInsightsRequest): Promise<CompsInsightsResponse> {
    return this.call<CompsInsightsResponse>('/comps/insights', 'POST', { data: request })
  }
  getSubmarkets(): Promise<CompsSubmarketMappings[]> {
    const ALL_SUBMARKETS_LIMIT = 963
    // Hardcoded limit for now since we need to flag the 53 submarkets that are avaiable to us
    return this.call<CompsSubmarketMappings[]>(`/comps/submarkets?limit=${ALL_SUBMARKETS_LIMIT}`, 'GET')
  }
  getSubmarketShape(submarketId: string): Promise<{ shape: CompsSubmarketMappings['shape'] }> {
    return this.call<{ shape: CompsSubmarketMappings['shape'] }>(`/comps/shape/${submarketId}`, 'GET')
  }
}
